const generateSystemPlan = (galX: number, galY: number, location: UserLocation): string => {

    if (location) {
        return generateSystemPlanRelative(galX, galY, location.coordinates.galaxy.attributes.x, location.coordinates.galaxy.attributes.y);
    } else {
        return `https://www.swcombine.com/members/cockpit/travel/directed.php?travelClass=2&supplied=1&galX=${galX}&galY=${galY}`
    }
}

const SCAN_ANGLE = 22.5;

const generateSystemPlanRelative = (galX: number, galY: number, prevX: number, prevY: number): string => {
    let x, y;
    const direction = relativeDirectionHyper(galX, galY, prevX, prevY);

    switch (direction) {
        case 'N':
            x = 10;
            y = 0;
            break;
        case "NW":
            x = 0;
            y = 0;
            break;
        case 'NE':
            x = 19;
            y = 0;
            break;
        case 'E':
            x = 19;
            y = 10;
            break;
        case 'SE':
            x = 19;
            y = 19;
            break;
        case 'W':
            x = 0;
            y = 10;
            break;
        case 'SW':
            x = 0;
            y = 19;
            break;
        case 'S':
            x = 10;
            y = 19;
    }

    return `https://www.swcombine.com/members/cockpit/travel/directed.php?travelClass=2&supplied=1&galX=${galX}&galY=${galY}&sysX=${x}&sysY=${y}`
}


const relativeDirection = (refX: number, refY: number, x: number, y: number) => {
    let tan = Math.atan2(x - refX, y - refY);
    let degs = tan * (180 / Math.PI);

    if (degs >= (0 - SCAN_ANGLE) && degs <= (0 + SCAN_ANGLE)) {
        return 'N';
    } else if (degs >= (-45 - SCAN_ANGLE) && degs <= (-45 + SCAN_ANGLE)) {
        return 'NW'
    } else if (degs >= (45 - SCAN_ANGLE) && degs <= (45 + SCAN_ANGLE)) {
        return 'NE'
    } else if (degs >= (90 - SCAN_ANGLE) && degs <= (90 + SCAN_ANGLE)) {
        return 'E'
    } else if (degs >= (135 - SCAN_ANGLE) && degs <= (135 + SCAN_ANGLE)) {
        return 'SE'
    } else if (degs >= (-90 - SCAN_ANGLE) && degs <= (-90 + SCAN_ANGLE)) {
        return 'W'
    } else if (degs >= (-135 - SCAN_ANGLE) && degs <= (-135 + SCAN_ANGLE)) {
        return 'SW'
    } else {
        return 'S'
    }
}

const relativeDirectionHyper = (refX: number, refY: number, x: number, y: number) => {
    const dx = x - refX;
    const dy = y - refY;

    if (dx === 0 && dy === 0) {
        return 'N/A';
    }

    const abs_dx = Math.abs(dx);
    const abs_dy = Math.abs(dy);


    if (abs_dx > abs_dy * 2) {
        return dx > 0 ? 'E' : 'W';
    }

    if (abs_dy > abs_dx * 2) {
        return dy > 0 ? 'N' : 'S';
    }
    if (dx > 0) {
        return dy > 0 ? 'NE' : 'SE';
    } else {
        return dy > 0 ? 'NW' : 'SW';
    }
}



const getDistance = (x1: number, y1: number, x2: number, y2: number) => {
    return Math.max(Math.abs(x1 - x2), Math.abs(y1 - y2));
}

export {generateSystemPlan, generateSystemPlanRelative, relativeDirection, relativeDirectionHyper, getDistance};
